export default "__VITE_ASSET__28d5970f__"